import Projects from "./Projects/Projects";

export { Projects };


// WEBPACK FOOTER //
// ./src/views/Projects/index.js